import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/reviews/useReviewQueryKeys.ts
var t = e("reviews", {
	listing: (e, t) => t ? [
		"listing",
		e,
		t
	] : ["listing", e],
	bookingReview: (e) => ["booking-review", e],
	detail: (e) => ["detail", e],
	aggregate: (e) => ["aggregate", e],
	workspace: () => ["workspace"],
	workspaceUnanswered: () => ["workspace-unanswered"],
	workspaceAggregate: () => ["workspace-aggregate"],
	workspaceTags: (e) => e ? ["workspace-tags", e] : ["workspace-tags"],
	hostReviews: (e, t) => t ? [
		"host-reviews",
		e,
		t
	] : ["host-reviews", e],
	hostStats: (e) => ["host-stats", e],
	hostReviewSummary: (e) => ["host-review-summary", e]
});
//#endregion
export { t as reviewQueryKeys };
